import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=2f0fa6b6&scoped=true"
import script from "./CellRendererActions.vue?vue&type=script&lang=js"
export * from "./CellRendererActions.vue?vue&type=script&lang=js"
import style0 from "./CellRendererActions.vue?vue&type=style&index=0&id=2f0fa6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0fa6b6",
  null
  
)

export default component.exports